import { AfterViewInit, Component, DestroyRef, inject, OnInit, ViewEncapsulation } from '@angular/core';

import { NotificationService } from '../../service/notification.service';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AsyncPipe, ViewportScroller } from '@angular/common';
import { BugNotificationCardComponent } from './bug-notification-card/bug-notification-card.component';
import { GlobalNotificationEntity } from '../../models/notifications/notification-entity.model';
import { ActivatedRoute } from '@angular/router';
import { LayoutContainerComponent } from '../../layouts/layout-container/layout-container.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ibp-bug-notifications-overview',
  standalone: true,
  templateUrl: './bug-notifications-overview.component.html',
  imports: [
    AsyncPipe,
    BugNotificationCardComponent,
    LayoutContainerComponent,
    CommonModule],
  encapsulation: ViewEncapsulation.None,
})
export class BugNotificationsOverviewComponent implements OnInit, AfterViewInit {
  private notificationService: NotificationService = inject(NotificationService);
  private viewportScroller: ViewportScroller = inject(ViewportScroller);
  private activedRoute: ActivatedRoute = inject(ActivatedRoute);
  private destroyRef$: DestroyRef = inject(DestroyRef);

  public notifications$: Observable<GlobalNotificationEntity[]>;

  ngOnInit() {
    this.notifications$ = this.notificationService.getOverviewBugNotifications().pipe(takeUntilDestroyed(this.destroyRef$));
  }

  ngAfterViewInit() {
    this.activedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef$)).subscribe(params => {
      if (params?.id) {
        this.viewportScroller.setOffset([0, 100]);
        this.viewportScroller.scrollToAnchor(params.id);
      }
    })
  }
}
